var Ue = Object.defineProperty, Ve = Object.defineProperties;
var Xe = Object.getOwnPropertyDescriptors;
var _ = Object.getOwnPropertySymbols;
var oe = Object.prototype.hasOwnProperty, te = Object.prototype.propertyIsEnumerable;
var ee = (e, t, o) => t in e ? Ue(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o, l = (e, t) => {
  for (var o in t || (t = {}))
    oe.call(t, o) && ee(e, o, t[o]);
  if (_)
    for (var o of _(t))
      te.call(t, o) && ee(e, o, t[o]);
  return e;
}, g = (e, t) => Ve(e, Xe(t));
var b = (e, t) => {
  var o = {};
  for (var n in e)
    oe.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
  if (e != null && _)
    for (var n of _(e))
      t.indexOf(n) < 0 && te.call(e, n) && (o[n] = e[n]);
  return o;
};
import { jsx as v, jsxs as de } from "react/jsx-runtime";
import { useRef as $, useEffect as Ye, cloneElement as Be, useState as re, useCallback as A } from "react";
import { O as ce, g as He } from "./OptionalPortal-sP4Hf4UO.js";
import { d as Ze, e as qe } from "./get-size-Bc1Pz5yf.js";
import { c as Ge } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as Je } from "./use-resolved-styles-api-D-aL_8KF.js";
import { u as Qe } from "./use-styles-DToiHEa6.js";
import { f as fe, u as j, B as We, c as eo } from "./factory-ueRxoNOV.js";
import { u as oo } from "./DirectionProvider-CT8S13Cp.js";
import { F as to, g as ro, u as no, a as ao } from "./use-floating-auto-update-Bm7DFrip.js";
import { O as so } from "./Overlay-ClwECLq6.js";
import { T as ue } from "./Transition-esp-rpzm.js";
import { c as io } from "./create-safe-context-DqDyoPVE.js";
import { r as lo } from "./rem-CMQJ_ZTp.js";
import { u as co, F as fo } from "./FocusTrap-C77tjG9E.js";
import { u as pe } from "./use-merged-ref-n551Tfbr.js";
import { i as uo } from "./is-element-C00Aie10.js";
import { u as po, o as mo, s as go, l as ne, f as ae, i as se, b as wo, c as ho } from "./floating-ui.react-DiT1zkFi.js";
import { u as yo } from "./use-uncontrolled-BT_j5D2R.js";
import { u as ie } from "./use-reduced-motion-C9DbPZfj.js";
import { u as vo } from "./use-id-D2tGiO9x.js";
const Po = () => {
};
function xo(e, t = { active: !0 }) {
  return typeof e != "function" || !t.active ? t.onKeyDown || Po : (o) => {
    var n;
    o.key === "Escape" && (e(o), (n = t.onTrigger) == null || n.call(t));
  };
}
const le = ["mousedown", "touchstart"];
function Oo(e, t, o) {
  const n = $(null);
  return Ye(() => {
    const c = (d) => {
      const { target: i } = d != null ? d : {};
      if (Array.isArray(o)) {
        const s = (i == null ? void 0 : i.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(i) && i.tagName !== "HTML";
        o.every((f) => !!f && !d.composedPath().includes(f)) && !s && e();
      } else n.current && !n.current.contains(i) && e();
    };
    return (t || le).forEach((d) => document.addEventListener(d, c)), () => {
      (t || le).forEach((d) => document.removeEventListener(d, c));
    };
  }, [n, e, o]), n;
}
const [Do, me] = io(
  "Popover component was not found in the tree"
);
var ge = { dropdown: "m_38a85659", arrow: "m_a31dc6c1", overlay: "m_3d7bc908" };
const bo = {}, K = fe((e, t) => {
  var S, O, P, x, E;
  const o = j("PopoverDropdown", bo, e), T = o, {
    className: n,
    style: c,
    vars: d,
    children: i,
    onKeyDownCapture: s,
    variant: a,
    classNames: f,
    styles: p
  } = T, w = b(T, [
    "className",
    "style",
    "vars",
    "children",
    "onKeyDownCapture",
    "variant",
    "classNames",
    "styles"
  ]), r = me(), h = co({
    opened: r.opened,
    shouldReturnFocus: r.returnFocus
  }), R = r.withRoles ? {
    "aria-labelledby": r.getTargetId(),
    id: r.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {}, C = pe(t, r.floating);
  return r.disabled ? null : /* @__PURE__ */ v(ce, g(l({}, r.portalProps), { withinPortal: r.withinPortal, children: /* @__PURE__ */ v(
    ue,
    g(l({
      mounted: r.opened
    }, r.transitionProps), {
      transition: ((S = r.transitionProps) == null ? void 0 : S.transition) || "fade",
      duration: (P = (O = r.transitionProps) == null ? void 0 : O.duration) != null ? P : 150,
      keepMounted: r.keepMounted,
      exitDuration: typeof ((x = r.transitionProps) == null ? void 0 : x.exitDuration) == "number" ? r.transitionProps.exitDuration : (E = r.transitionProps) == null ? void 0 : E.duration,
      children: (F) => {
        var N, z;
        return /* @__PURE__ */ v(fo, { active: r.trapFocus && r.opened, innerRef: C, children: /* @__PURE__ */ de(
          We,
          g(l(g(l(l({}, R), w), {
            variant: a,
            onKeyDownCapture: xo(
              () => {
                var I, k;
                (I = r.onClose) == null || I.call(r), (k = r.onDismiss) == null || k.call(r);
              },
              {
                active: r.closeOnEscape,
                onTrigger: h,
                onKeyDown: s
              }
            ),
            "data-position": r.placement,
            "data-fixed": r.floatingStrategy === "fixed" || void 0
          }), r.getStyles("dropdown", {
            className: n,
            props: o,
            classNames: f,
            styles: p,
            style: [
              g(l({}, F), {
                zIndex: r.zIndex,
                top: (N = r.y) != null ? N : 0,
                left: (z = r.x) != null ? z : 0,
                width: r.width === "target" ? void 0 : lo(r.width)
              }),
              r.resolvedStyles.dropdown,
              p == null ? void 0 : p.dropdown,
              c
            ]
          })), {
            children: [
              i,
              /* @__PURE__ */ v(
                to,
                l({
                  ref: r.arrowRef,
                  arrowX: r.arrowX,
                  arrowY: r.arrowY,
                  visible: r.withArrow,
                  position: r.placement,
                  arrowSize: r.arrowSize,
                  arrowRadius: r.arrowRadius,
                  arrowOffset: r.arrowOffset,
                  arrowPosition: r.arrowPosition
                }, r.getStyles("arrow", {
                  props: o,
                  classNames: f,
                  styles: p
                }))
              )
            ]
          })
        ) });
      }
    })
  ) }));
});
K.classes = ge;
K.displayName = "@mantine/core/PopoverDropdown";
const Ro = {
  refProp: "ref",
  popupType: "dialog"
}, we = fe((e, t) => {
  const p = j(
    "PopoverTarget",
    Ro,
    e
  ), { children: o, refProp: n, popupType: c } = p, d = b(p, ["children", "refProp", "popupType"]);
  if (!uo(o))
    throw new Error(
      "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const i = d, s = me(), a = pe(s.reference, ro(o), t), f = s.withRoles ? {
    "aria-haspopup": c,
    "aria-expanded": s.opened,
    "aria-controls": s.getDropdownId(),
    id: s.getTargetId()
  } : {};
  return Be(o, l(g(l(l(l({}, i), f), s.targetProps), {
    className: eo(
      s.targetProps.className,
      i.className,
      o.props.className
    ),
    [n]: a
  }), s.controlled ? null : { onClick: s.onToggle }));
});
we.displayName = "@mantine/core/PopoverTarget";
function Co(e) {
  if (e === void 0)
    return { shift: !0, flip: !0 };
  const t = l({}, e);
  return e.shift === void 0 && (t.shift = !0), e.flip === void 0 && (t.flip = !0), t;
}
function To(e, t) {
  const o = Co(e.middlewares), n = [mo(e.offset)];
  return o.shift && n.push(
    go(
      typeof o.shift == "boolean" ? { limiter: ne(), padding: 5 } : l({ limiter: ne(), padding: 5 }, o.shift)
    )
  ), o.flip && n.push(
    typeof o.flip == "boolean" ? ae() : ae(o.flip)
  ), o.inline && n.push(
    typeof o.inline == "boolean" ? se() : se(o.inline)
  ), n.push(wo({ element: e.arrowRef, padding: e.arrowOffset })), (o.size || e.width === "target") && n.push(
    ho(g(l({}, typeof o.size == "boolean" ? {} : o.size), {
      apply(a) {
        var f = a, { rects: c, availableWidth: d, availableHeight: i } = f, s = b(f, ["rects", "availableWidth", "availableHeight"]);
        var r, h;
        const w = (h = (r = t().refs.floating.current) == null ? void 0 : r.style) != null ? h : {};
        o.size && (typeof o.size == "object" && o.size.apply ? o.size.apply(l({ rects: c, availableWidth: d, availableHeight: i }, s)) : Object.assign(w, {
          maxWidth: `${d}px`,
          maxHeight: `${i}px`
        })), e.width === "target" && Object.assign(w, {
          width: `${c.reference.width}px`
        });
      }
    }))
  ), n;
}
function So(e) {
  const [t, o] = yo({
    value: e.opened,
    defaultValue: e.defaultOpened,
    finalValue: !1,
    onChange: e.onChange
  }), n = $(t), c = () => {
    t && !e.disabled && o(!1);
  }, d = () => !e.disabled && o(!t), i = po({
    strategy: e.strategy,
    placement: e.position,
    middleware: To(e, () => i)
  });
  return no({
    opened: t,
    position: e.position,
    positionDependencies: e.positionDependencies || [],
    floating: i
  }), ie(() => {
    var s;
    (s = e.onPositionChange) == null || s.call(e, i.placement);
  }, [i.placement]), ie(() => {
    var s, a;
    t !== n.current && (t ? (a = e.onOpen) == null || a.call(e) : (s = e.onClose) == null || s.call(e)), n.current = t;
  }, [t, e.onClose, e.onOpen]), {
    floating: i,
    controlled: typeof e.opened == "boolean",
    opened: t,
    onClose: c,
    onToggle: d
  };
}
const Eo = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transitionProps: { transition: "fade", duration: 150 },
  middlewares: { flip: !0, shift: !0, inline: !1 },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: !0,
  withinPortal: !0,
  closeOnEscape: !0,
  trapFocus: !1,
  withRoles: !0,
  returnFocus: !1,
  withOverlay: !1,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: He("popover"),
  __staticSelector: "Popover",
  width: "max-content"
}, Fo = Ge((e, { radius: t, shadow: o }) => ({
  dropdown: {
    "--popover-radius": t === void 0 ? void 0 : qe(t),
    "--popover-shadow": Ze(o)
  }
}));
function M(e) {
  var Z, q, G, J, Q, W;
  const t = j("Popover", Eo, e), H = t, {
    children: o,
    position: n,
    offset: c,
    onPositionChange: d,
    positionDependencies: i,
    opened: s,
    transitionProps: a,
    onExitTransitionEnd: f,
    onEnterTransitionEnd: p,
    width: w,
    middlewares: r,
    withArrow: h,
    arrowSize: R,
    arrowOffset: C,
    arrowRadius: T,
    arrowPosition: S,
    unstyled: O,
    classNames: P,
    styles: x,
    closeOnClickOutside: E,
    withinPortal: F,
    portalProps: N,
    closeOnEscape: z,
    clickOutsideEvents: I,
    trapFocus: k,
    onClose: he,
    onDismiss: D,
    onOpen: ye,
    onChange: ve,
    zIndex: Pe,
    radius: xe,
    shadow: Oe,
    id: De,
    defaultOpened: be,
    __staticSelector: L,
    withRoles: Re,
    disabled: U,
    returnFocus: Ce,
    variant: Te,
    keepMounted: Se,
    vars: Ee,
    floatingStrategy: V,
    withOverlay: Fe,
    overlayProps: y
  } = H, Ne = b(H, [
    "children",
    "position",
    "offset",
    "onPositionChange",
    "positionDependencies",
    "opened",
    "transitionProps",
    "onExitTransitionEnd",
    "onEnterTransitionEnd",
    "width",
    "middlewares",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "unstyled",
    "classNames",
    "styles",
    "closeOnClickOutside",
    "withinPortal",
    "portalProps",
    "closeOnEscape",
    "clickOutsideEvents",
    "trapFocus",
    "onClose",
    "onDismiss",
    "onOpen",
    "onChange",
    "zIndex",
    "radius",
    "shadow",
    "id",
    "defaultOpened",
    "__staticSelector",
    "withRoles",
    "disabled",
    "returnFocus",
    "variant",
    "keepMounted",
    "vars",
    "floatingStrategy",
    "withOverlay",
    "overlayProps"
  ]), X = Qe({
    name: L,
    props: t,
    classes: ge,
    classNames: P,
    styles: x,
    unstyled: O,
    rootSelector: "dropdown",
    vars: Ee,
    varsResolver: Fo
  }), { resolvedStyles: ze } = Je({ classNames: P, styles: x, props: t }), Y = $(null), [Ie, ke] = re(null), [_e, Ae] = re(null), { dir: Me } = oo(), B = vo(De), u = So({
    middlewares: r,
    width: w,
    position: ao(Me, n),
    offset: typeof c == "number" ? c + (h ? R / 2 : 0) : c,
    arrowRef: Y,
    arrowOffset: C,
    onPositionChange: d,
    positionDependencies: i,
    opened: s,
    defaultOpened: be,
    onChange: ve,
    onOpen: ye,
    onClose: he,
    onDismiss: D,
    strategy: V,
    disabled: U
  });
  Oo(
    () => {
      E && (u.onClose(), D == null || D());
    },
    I,
    [Ie, _e]
  );
  const $e = A(
    (m) => {
      ke(m), u.floating.refs.setReference(m);
    },
    [u.floating.refs.setReference]
  ), je = A(
    (m) => {
      Ae(m), u.floating.refs.setFloating(m);
    },
    [u.floating.refs.setFloating]
  ), Ke = A(() => {
    var m;
    (m = a == null ? void 0 : a.onExited) == null || m.call(a), f == null || f();
  }, [a == null ? void 0 : a.onExited, f]), Le = A(() => {
    var m;
    (m = a == null ? void 0 : a.onEntered) == null || m.call(a), p == null || p();
  }, [a == null ? void 0 : a.onEntered, p]);
  return /* @__PURE__ */ de(
    Do,
    {
      value: {
        returnFocus: Ce,
        disabled: U,
        controlled: u.controlled,
        reference: $e,
        floating: je,
        x: u.floating.x,
        y: u.floating.y,
        arrowX: (G = (q = (Z = u.floating) == null ? void 0 : Z.middlewareData) == null ? void 0 : q.arrow) == null ? void 0 : G.x,
        arrowY: (W = (Q = (J = u.floating) == null ? void 0 : J.middlewareData) == null ? void 0 : Q.arrow) == null ? void 0 : W.y,
        opened: u.opened,
        arrowRef: Y,
        transitionProps: g(l({}, a), { onExited: Ke, onEntered: Le }),
        width: w,
        withArrow: h,
        arrowSize: R,
        arrowOffset: C,
        arrowRadius: T,
        arrowPosition: S,
        placement: u.floating.placement,
        trapFocus: k,
        withinPortal: F,
        portalProps: N,
        zIndex: Pe,
        radius: xe,
        shadow: Oe,
        closeOnEscape: z,
        onDismiss: D,
        onClose: u.onClose,
        onToggle: u.onToggle,
        getTargetId: () => `${B}-target`,
        getDropdownId: () => `${B}-dropdown`,
        withRoles: Re,
        targetProps: Ne,
        __staticSelector: L,
        classNames: P,
        styles: x,
        unstyled: O,
        variant: Te,
        keepMounted: Se,
        getStyles: X,
        resolvedStyles: ze,
        floatingStrategy: V
      },
      children: [
        o,
        Fe && /* @__PURE__ */ v(
          ue,
          {
            transition: "fade",
            mounted: u.opened,
            duration: (a == null ? void 0 : a.duration) || 250,
            exitDuration: (a == null ? void 0 : a.exitDuration) || 250,
            children: (m) => /* @__PURE__ */ v(ce, { withinPortal: F, children: /* @__PURE__ */ v(
              so,
              l(l({}, y), X("overlay", {
                className: y == null ? void 0 : y.className,
                style: [m, y == null ? void 0 : y.style]
              }))
            ) })
          }
        )
      ]
    }
  );
}
M.Target = we;
M.Dropdown = K;
M.displayName = "@mantine/core/Popover";
M.extend = (e) => e;
export {
  M as P
};
